export default __webpack_public_path__ + "static/media/udacity-U-logo-120.df7aa1bd.webp";